import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import UIImage from './ui/UIImage';
import UIInputText from './ui/UIInputText';
import UISelectValue from './ui/UISelectValue';


const VideoPlayerModule = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialStateVideoPlayer = {
    type: 'VideoPlayer',
    image: '',
    description: {
      en: '',
    },
    youtube: '',
    url: '',
    vimeo: '',
    twitchChannel: '',
    size: null,
    autoplay: false,
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialStateVideoPlayer);

  const [youtube, setYoutube] = useState('');
  const [vimeo, setVimeo] = useState('');
  const [twitchChannel, setTwitchChannel] = useState('');
  const [url, setUrl] = useState('');
  const [size, setSize] = useState(null);
  const [autoplay, setAutoplay] = useState(false);

  const [description, setDescription] = useState({ 'en': '' });
  const [image, setImage] = useState('');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        const {
          description: currentDescription,
          image: currentImage,
          url: currentUrl,
          vimeo: currentVimeo,
          youtube: currentYoutube,
          twitchChannel: currentTwitchChannel,
          size: currentSize,
          autoplay: currentAutoplay,
        } = component;

        setState(component);
        setDescription(currentDescription);
        setImage(currentImage);
        setUrl(currentUrl);
        setYoutube(currentYoutube);
        setVimeo(currentVimeo);
        setTwitchChannel(currentTwitchChannel);
        setSize(currentSize);
        setAutoplay(currentAutoplay);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);

    const construction = {
      type: state.type,
      compId: state.compId || '',
      description: { ...description },
      image,
      url,
      vimeo,
      youtube,
      twitchChannel,
      size,
      autoplay,
    };

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    description,
    url,
    vimeo,
    youtube,
    twitchChannel,
    image,
    size,
    autoplay,
  ]);


  return (
    <div className="w-full text-black">

      <UIInputText label={'Youtube'}
        setValue={setYoutube}
        value={youtube}
      />
      <UIInputText label={'URL'}
        setValue={setUrl}
        value={url}
      />
      <UIInputText label={'Vimeo'}
        setValue={setVimeo}
        value={vimeo}
      />
      <UIInputText label={'Twitch Channel'}
        setValue={setTwitchChannel}
        value={twitchChannel}
      />
      <UIImage label={'Poster Image'}
        Image={image}
        setImage={setImage}
      />
      <UIInputText label={'Foot note'}
        setValue={(value) => setDescription({ 'en': value })}
        value={description[activeLanguage]}
      />
      <UISelectValue label={'Size'}
        setValue={setSize}
        value={size}
        options={[
          { value: 'full', label: 'Full' },
          { value: 'large', label: 'Large' },
          { value: 'medium', label: 'Medium' },
          { value: 'small', label: 'Small' },
          { value: 'tiny', label: 'Tiny' },
        ]}
      />
       <div className="flex w-full my-6 items-center text-black">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Autoplay</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            value={autoplay}
            onChange={() => setAutoplay(!autoplay)}
            checked={autoplay}
            id="autoplayCheckbox"
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="autoplayCheckbox" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>

    </div>
  );
};

VideoPlayerModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
};
VideoPlayerModule.defaultProps = {
  reusableComponent: null,
};

export default VideoPlayerModule;
